<div class="step-content">
    <div class="info-section">
    <div class="payee-checkbox-block" *ngIf="showServiceLocationCheckbox">
        <app-checkbox id="serviceLocation" layout='horizontal' [for]="'serviceLocation-Input'"
            (click)="onServiceLocationToggle($event)"
            [checkboxLabels]="['Is Payee address same as physical address?']"
            [formGroup]="serviceCheckForm"></app-checkbox>
        <div class="existing-payee-prefill" *ngIf="isExistingTinNewLocationFlow && existingPayeeOptions.length">
            <app-select-input class="story-drop" [for]="'existingPayee-select'" [label]="'Prefill from existing Payee'"
                [options]="existingPayeeOptions" [placeholder]="'Select payee address'" [isSearchable]="true"
                [control]="selectedExistingPayeeControl" (selectionChanged)="onExistingPayeeSelected()">
            </app-select-input>
            <app-button class="clear-existing-payee" [label]="'Clear'" [isFilled]="false" [buttonType]="'secondary'"
                [isDisabled]="!hasExistingPayeeSelection" (click)="clearExistingPayee()"></app-button>
        </div>
    </div>
    <div class="section-title">Payee Info</div>

    <form [formGroup]="payeeFormGroup" class="form-grid">
        <div class="form-group">
            <app-text-input [label]="'Payee name'" [for]="'payeeName-Input'" [placeholder]="''"
                [title]="(payeeFormGroup.controls['payeeName'].value?.length || 0) > 25 ? (payeeFormGroup.controls['payeeName'].value || '') : ''"
                [ngClass]="payeeFormGroup.controls['payeeName'].errors ? 'showAsterisk' : 'hideAsterisk'"
                [control]="payeeFormGroup.controls['payeeName']"
                [maxLength]="FIELD_LIMITS['payeeName']['maxLength']"></app-text-input>
        </div>
        <div class="form-group">
            <div class="marg-t-35 find-wdth">
                <label class="location-field" for="payeeLocation">Address 1 <span class="asterisk"
                        *ngIf="payeeFormGroup.controls['payeeLocation'].errors">*</span></label>
                <input (focus)="onFocus()" data-type="payee" (blur)="onBlur($event)" formControlName="payeeLocation"
                    (ngModelChange)="onAddress1Change($event,'payee')" #locationInput type="text"
                    [maxLength]="FIELD_LIMITS['location']['maxLength']"
                    id="payeeLocation" name="payeeLocation" aria-label="Payee address"
                    [title]="(payeeFormGroup.controls['payeeLocation'].value?.length || 0) > 25 ? (payeeFormGroup.controls['payeeLocation'].value || '') : ''"
                    class="findform-input location-fieldbox">
                <div *ngIf="showErrorPayee" class="finddentist-validator">Required</div>
                <div *ngIf="(showFulladdressErrorPayee  && payeeFormGroup.controls['payeeZip']?.errors)" class="finddentist-validator">Please type full home address</div>
            </div>
        </div>

        <div class="form-group">
            <app-text-input [label]="'Address 2'" [for]="'payeeAddress2-field'" [placeholder]="''"
                [ngClass]="payeeFormGroup.controls['payeeAddress2'].errors ? 'showAsterisk' : 'hideAsterisk'"
                [control]="payeeFormGroup.controls['payeeAddress2']"
                [title]="(payeeFormGroup.controls['payeeAddress2'].value?.length || 0) > 25 ? (payeeFormGroup.controls['payeeAddress2'].value || '') : ''"
                [maxLength]="FIELD_LIMITS['payeeAddress2']['maxLength']"></app-text-input>
        </div>

        <div class="form-group">
            <app-text-input [label]="'City'" [for]="'payeeCity-Input'" [placeholder]="''"
                [ngClass]="payeeFormGroup.controls['payeeCity'].errors ? 'showAsterisk' : 'hideAsterisk'"
                [control]="payeeFormGroup.controls['payeeCity']"
                [maxLength]="FIELD_LIMITS['payeeCity']['maxLength']"></app-text-input>
        </div>

        <div class="form-group">
            <app-select-input class="story-drop" [for]="'payeeState-select'" [label]="'State'" [placeholder]="''"
                [ngClass]="payeeFormGroup.controls['payeeState'].errors ? 'showAsterisk' : 'hideAsterisk'" [isSearchable]="true"
                [options]="stateOptions" [placeholder]="'None selected'"
                [control]="payeeFormGroup.controls['payeeState']">
            </app-select-input>
        </div>

        <div class="form-group">
            <app-text-input [label]="'ZIP'" [for]="'payeeZip-Input'" [placeholder]="''"
                [ngClass]="payeeFormGroup.controls['payeeZip'].errors ? 'showAsterisk' : 'hideAsterisk'"
                [control]="payeeFormGroup.controls['payeeZip']" [fieldType]="'This field'"
                [errorMessages]="VALIDATION_MESSAGES['zip']"
                (keypress)="restrictNonNumeric($event)" 
                (paste)="restrictNonNumericPaste($event)"
                [maxLength]="FIELD_LIMITS['payeeZip']['maxLength']"></app-text-input>
        </div>

        <div class="form-group">
            <app-text-input label="Phone number" [control]="payeeFormGroup.controls['payeePhone']"
                [for]="'payeePhone-number'" appPhoneMask [maxLength]="FIELD_LIMITS['payeePhone']['maxLength']"
                [ngClass]="payeeFormGroup.controls['payeePhone'].errors ? 'showAsterisk' : 'hideAsterisk'"></app-text-input>
        </div>

        <div class="form-group">
            <app-text-input
                label="Email"
                [control]="payeeFormGroup.controls['payeeEmail']"
                [title]="(payeeFormGroup.controls['payeeEmail'].value?.length || 0) > 25 ? (payeeFormGroup.controls['payeeEmail'].value || '') : ''"
                [for]="'payeeEmail-Input'"
                [maxLength]="FIELD_LIMITS['payeeEmail']['maxLength']">
            </app-text-input>
        </div>


        <div class="form-group">
            <app-text-input [label]="'Type 2 NPI'" [for]="'npi2-Input'" [placeholder]="''"
                [control]="payeeFormGroup.controls['npi2']" (keypress)="restrictNonNumeric($event)"
                [errorMessages]="VALIDATION_MESSAGES['npi2']"
                [maxLength]="FIELD_LIMITS['npi2']['maxLength']"></app-text-input>
        </div>
    </form>
    </div>

    <div class="info-section">
    <div class="section-title">TIN Info</div>

    <form [formGroup]="tinFormGroup" class="form-grid">
        <div class="form-group">
            <app-select-input class="story-drop" [for]="'taxIdType-select'" [label]="'Tax ID type'" [placeholder]="''"
                [ngClass]="tinFormGroup.controls['taxIdType'].errors ? 'showAsterisk' : 'hideAsterisk'"
                [options]="taxIdTypes" [placeholder]="'None selected'" [control]="tinFormGroup.controls['taxIdType']">
            </app-select-input>
        </div>
        <div class="form-group">
            <app-text-input [label]="'Tax ID'" [for]="'taxId-Input'" [placeholder]="''"
                [ngClass]="tinFormGroup.controls['taxId'].errors ? 'showAsterisk' : 'hideAsterisk'"
                [control]="tinFormGroup.controls['taxId']" (keypress)="restrictNonNumeric($event)"
                [errorMessages]="VALIDATION_MESSAGES['taxId']"
                [maxLength]="FIELD_LIMITS['taxId']['maxLength']"></app-text-input>
        </div>
        <div class="form-group">
            <app-text-input [label]="'Tax entity name'" [for]="'taxEntityName-Input'" [placeholder]="''"
                [title]="(tinFormGroup.controls['taxEntityName'].value?.length || 0) > 25 ? (tinFormGroup.controls['taxEntityName'].value || '') : ''"
                [ngClass]="tinFormGroup.controls['taxEntityName'].errors ? 'showAsterisk' : 'hideAsterisk'"
                [control]="tinFormGroup.controls['taxEntityName']"
                [maxLength]="FIELD_LIMITS['taxEntityName']['maxLength']"></app-text-input>
        </div>
        <div class="form-group">
            <div class="marg-t-35 find-wdth">
                <label class="location-field" for="location">Address 1 <span class="asterisk"
                        *ngIf="tinFormGroup.controls['location'].errors">*</span></label>
                <input (focus)="onFocus()" data-type="tin" (blur)="onBlur($event)" formControlName="location"
                    (ngModelChange)="onAddress1Change($event,'tin')" #locationInput type="text"
                    [maxLength]="FIELD_LIMITS['location']['maxLength']"
                    id="location" name="location" aria-label="Tax entity address"
                    [title]="(tinFormGroup.controls['location'].value?.length || 0) > 25 ? (tinFormGroup.controls['location'].value || '') : ''"
                    class="findform-input location-fieldbox">
                <div *ngIf="showError" class="finddentist-validator">Required</div>
                <div *ngIf="(showFulladdressError  && tinFormGroup.controls['zip']?.errors)" class="finddentist-validator">Please type full home address</div>
            </div>
        </div>

        <div class="form-group">
            <app-text-input [label]="'Address 2'" [for]="'address2-field'" [placeholder]="''"
                [ngClass]="tinFormGroup.controls['address2'].errors ? 'showAsterisk' : 'hideAsterisk'"
                [title]="(tinFormGroup.controls['address2'].value?.length || 0) > 25 ? (tinFormGroup.controls['address2'].value || '') : ''"
                [control]="tinFormGroup.controls['address2']"
                [maxLength]="FIELD_LIMITS['address2']['maxLength']"></app-text-input>
        </div>

        <div class="form-group">
            <app-text-input [label]="'City'" [for]="'City-Input'" [placeholder]="''"
                [ngClass]="tinFormGroup.controls['city'].errors ? 'showAsterisk' : 'hideAsterisk'"
                [control]="tinFormGroup.controls['city']"
                [maxLength]="FIELD_LIMITS['city']['maxLength']"></app-text-input>
        </div>

        <div class="form-group">
            <app-select-input class="story-drop" [for]="'LicenseState-select'" [label]="'State'" [placeholder]="''"
                [ngClass]="tinFormGroup.controls['state'].errors ? 'showAsterisk' : 'hideAsterisk'" [isSearchable]="true"
                [options]="stateOptions" [placeholder]="'None selected'" [control]="tinFormGroup.controls['state']">
            </app-select-input>
        </div>

        <div class="form-group">
            <app-text-input [label]="'ZIP'" [for]="'ZIP-Input'" [placeholder]="''"
                [ngClass]="tinFormGroup.controls['zip'].errors ? 'showAsterisk' : 'hideAsterisk'"
                [control]="tinFormGroup.controls['zip']" [fieldType]="'This field'"
                [errorMessages]="VALIDATION_MESSAGES['zip']"
                (keypress)="restrictNonNumeric($event)" 
                (paste)="restrictNonNumericPaste($event)"
                [maxLength]="FIELD_LIMITS['zip']['maxLength']"></app-text-input>
        </div>

        <div class="form-group">
            <app-text-input label="Phone number" [control]="tinFormGroup.controls['phone']" [for]="'phone-number'"
                appPhoneMask [maxLength]="FIELD_LIMITS['phone']['maxLength']"
                [ngClass]="tinFormGroup.controls['phone'].errors ? 'showAsterisk' : 'hideAsterisk'"></app-text-input>
        </div>

        <div class="form-group" *ngIf="!isTinFromDW">
            <app-date-input [ngClass]="tinFormGroup.controls['effectiveDate'].errors ? 'showAsterisk' : 'hideAsterisk'"
                [for]="'effectiveDate-Input'" [minDate]="minDate" label="Effective date"
                [errorMessages]="VALIDATION_MESSAGES['effectiveDate']"
                [control]="tinFormGroup.controls['effectiveDate']">
            </app-date-input>
        </div>

    </form>
    </div>

    <ng-container *ngIf="showW9Section && isW9Required">
        <ng-content select="[document-actions-header]"></ng-content>

        <div class="sign-section" [class.w9-completed]="(w9Documents && w9Documents.length) || !!w9DocumentId">
            <div class="sign-cards">
                <div class="sign-card" [class.is-completed]="w9Documents && w9Documents.length">
                    <div class="card-content">
                        <div class="icon-wrapper" [class.is-completed]="w9Documents && w9Documents.length">
                            📄
                        </div>
                        <span class="card-title">
                            W9 document
                            <span class="asterisk" *ngIf="!((w9Documents && w9Documents.length) || !!w9DocumentId)">*</span>
                        </span>
                    </div>
                    <div class="card-actions">
                        <span class="status-badge" [class.completed]="w9Documents && w9Documents.length">
                            {{ (w9Documents && w9Documents.length) ? 'Completed' : 'Not started' }}
                        </span>
                        <ng-container *ngIf="w9Documents && w9Documents.length; else uploadW9Button">
                            <button class="btn btn-outline cancel-btn" type="button" (click)="onViewDocument()" [disabled]="impersonatedUser">
                                View
                            </button>
                            <button class="iconwidth1" type="button" (click)="onDeleteW9Document(0)" [disabled]="impersonatedUser"
                                aria-label="Delete W9 document" title="Delete W9 document">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <polyline points="3 6 5 6 21 6"></polyline>
                                    <path d="M19 6l-1 14H6L5 6"></path>
                                    <path d="M10 11v6"></path>
                                    <path d="M14 11v6"></path>
                                    <path d="M9 6V4h6v2"></path>
                                </svg>
                            </button>
                        </ng-container>
                        <ng-template #uploadW9Button>
                            <button class="btn btn-outline cancel-btn" type="button" (click)="triggerFileSelect()" [disabled]="impersonatedUser">
                                Upload
                            </button>
                        </ng-template>
                    </div>
                </div>
            </div>

            <div *ngIf="!((w9Documents && w9Documents.length) || !!w9DocumentId)" class="w9-upload-control" [ngClass]="showW9Asterisk ? 'showAsterisk' : 'hideAsterisk'">
                <app-file-text-upload #w9Upload label="W9 document" [hideLabel]="true" [documents]="w9Documents" [required]="true"
                    docType="W9" (upload)="onUploadDocument($event)" (delete)="onDeleteW9Document($event.index)"
                    (view)="onViewDocument()" [buttonDisabled]="true"
                    [control]="tinFormGroup.controls['w9Control']" roadOnly="true" toolTip="Upload Document" deleteToolTip="Delete Document">
                </app-file-text-upload>
            </div>

            <div *ngIf="showDocError" class="finddentist-validator w9-doc-error">
                Please upload W9 form
            </div>
        </div>

        <ng-content select="[document-actions]"></ng-content>
    </ng-container>

    <div class="btn-div" *ngIf="showSaveAction">
        <div class="save-action-group">
            <span class="save-guidance" *ngIf="createNeedtoDisable()">
                Complete all required (*) fields to enable saving.
            </span>
            <div class="save-buttons">
                <button type="button" class="cancel-save-btn cancel-btn" (click)="onCancel()"
                    [disabled]="impersonatedUser">
                    Cancel
                </button>
                <button type="button" class="cancel-save-btn save-location-btn" id="signDocument"
                    [disabled]="createNeedtoDisable()" (click)="onSave()">
                    Save location
                </button>
            </div>
        </div>
    </div>

</div>